<template>
  <div id="pricing" class="mdc-layout-container pricing">
    <div class="content-section">
      <div class="container">
        <div class="title-wrap">
          <div class="detail">Pachete Găzduire & Mentenanță</div>
          <h1 class="display-heading">
            Descoperă prețurile noastre
          </h1>
          <p>
            Prețuri create pentru companii de toate dimensiunile. Știți
            întotdeauna ce veți plăti.
          </p>
        </div>
        <div class="w-layout-grid pricing-grid">
          <div class="card-container">
            <div class="price">
              $<span class="large-price-span">36</span>/lunar
            </div>
            <p class="pricing-description">Site Prezentare</p>
            <div class="w-layout-grid feature-grid">
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">25.000 de vizite lunare</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de pagini statice</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">Fara CMS</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de formulare lunar</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">CDN 50GB Trafic</div>
              </div>
            </div>
          </div>
          <div class="card-container">
            <div class="price">
              $<span class="large-price-span">54</span>/lunar
            </div>
            <p class="pricing-description">Site Prezentare + Blog</p>
            <div class="w-layout-grid feature-grid">
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100.000 de vizite lunare</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de pagini statice</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">2 Mii Postări pe blog</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">1000 de formulare lunar</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">CDN 200GB Trafic</div>
              </div>
            </div>
          </div>
          <div class="card-container">
            <div class="price">
              $<span class="large-price-span">111</span>/lunar
            </div>
            <p class="pricing-description">Business</p>
            <div class="w-layout-grid feature-grid">
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">500.000 de vizite lunare</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de pagini statice</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">10 Mii Postări pe blog</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">2000 de formulare lunar</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">CDN 400GB Trafic</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="testimonial-wrap">
        <img
          src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3616f32a33dacf0b716_Avatars.png"
          loading="lazy"
          alt=""
          class="avatars"
        />
        <div class="feature">
          Trusted by <span class="detail-bold">5,000+</span>
        </div>
      </div>
      <img
        src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e36151945163e71934f5_Plant%202%20SVG.svg"
        loading="lazy"
        alt=""
        class="plant-2"
      /><img
        src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e361c97df45caa09e12a_Plant%201%20SVG.svg"
        loading="lazy"
        alt=""
        class="plant-1"
      /> -->

      <div class="all-include container">
        <h3 class="title-2 cc-small">Toate planurile de găzduire includ</h3>
        <div class="feature_grid">
          <div id="w-feature1" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca2f2e7dec904d2c055c_pricing3.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Backups &amp; Mentenanță</h5>
            <p class="small-paragraph">
              Salvăm și creăm automat puncte de restaurare astfel încât să nu ne
              prindă niciodată neprevăzutul.<br />
            </p>
          </div>
          <div id="w-feature2" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca3b5c85ce7a16897831_pricing1.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Protecție prin Cloudflare<br /></h5>
            <p class="small-paragraph">Oferind viteză și securitate.<br /></p>
          </div>
          <div id="w-feature3" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca432e7dec3e942c0566_pricing20.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Controale SEO avansate<br /></h5>
            <p class="small-paragraph">
              Sitemap-uri automate și redirecționări 301 personalizabile pentru
              un control complet.<br />
            </p>
          </div>
          <div id="w-feature4" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca4a69305d9570ea80c7_pricing7.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Încărcări de pagini foarte rapide<br /></h5>
            <p class="small-paragraph">
              Cea mai rapidă găzduire pe internet prin rețeaua noastră de CDN de
              nivel 1.Folosind infrastructura Amazon, Cloudfront și Fastly.<br />
            </p>
          </div>
          <div id="w-feature5" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca5569305d47ffea80cb_pricing18.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">SSL și securitate încorporate<br /></h5>
            <p class="small-paragraph">
              24/7 monitorizarea găzduirii &amp; Certificatele SSL înseamnă că
              vă vom păstra site-ul în siguranță.<br />
            </p>
          </div>
          <div class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca6910ba2a291c7b2c4d_pricing12.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Scalare imediată<br /></h5>
            <p class="small-paragraph">
              Site-ul dvs. va fi rapid pentru primul sau al 1M -lea vizitator
              simultan. Nu vă faceți griji, puteți deveni popular peste
              noapte.<br />
            </p>
          </div>
        </div>

        <div class="title-wrap mt-5 pt-5">
          <div class="detail">Security Headers</div>
          <h1 class="display-heading">Cât de sigur este site-ul tău?</h1>
          <p>
            Hai să vedem, introdu in campul de mai jos domeniul tău. ex:
            surfverse.com
          </p>
          <form
            method="post"
            onsubmit="window.open('google.html', '_blank';return true;"
          >
            <input type="text" name="website" v-model="website" />
            <button type="submit" @click.stop.prevent="submit()">
              Verifica
            </button>
          </form>
        </div>
      </div>
    </div>
    <!-- Sectiunea 2 de pachete -->

    <div class="content-section">
      <div class="container">
        <div class="title-wrap">
          <div class="detail">Pachete Design &amp; Branding</div>
          <h1 class="display-heading">
            Ieși din anonimat cu designul personalizat
          </h1>
          <p>
            Prețuri create pentru companii de toate dimensiunile. Știți
            întotdeauna ce veți plăti. 100 lei ora x 40 ore proiectul = 4000 lei
          </p>
        </div>
        <div class="w-layout-grid pricing-grid">
          <div class="card-container">
            <div class="price">$<span class="large-price-span">1000</span></div>
            <p class="pricing-description">Prezentare Produs/Serviciu</p>
            <div class="w-layout-grid feature-grid">
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">Gazduire la noi</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">10 pagini personalizate</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">Fara CMS</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de formulare lunar</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">CDN 50GB Trafic</div>
              </div>
            </div>
          </div>
          <div class="card-container">
            <div class="price">$<span class="large-price-span">1500</span></div>
            <p class="pricing-description">Site Prezentare + Blog</p>
            <div class="w-layout-grid feature-grid">
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100.000 de vizite lunare</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de pagini statice</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">2 Mii Postări pe blog</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">1000 de formulare lunar</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">CDN 200GB Trafic</div>
              </div>
            </div>
          </div>
          <div id="w-node-70813f6bb61e-7d4084b0" class="card-container">
            <div class="price">
              $<span class="large-price-span">111</span>/lunar
            </div>
            <p class="pricing-description">Business</p>
            <div class="w-layout-grid feature-grid">
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">500.000 de vizite lunare</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">100 de pagini statice</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">10 Mii Postări pe blog</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">2000 de formulare lunar</div>
              </div>
              <div class="feature-wrap">
                <img
                  src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3613dc8c0805c7f8baf_Check%20SVG.svg"
                  loading="lazy"
                  alt=""
                  class="check-svg"
                />
                <div class="feature">CDN 400GB Trafic</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="testimonial-wrap">
        <img
          src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e3616f32a33dacf0b716_Avatars.png"
          loading="lazy"
          alt=""
          class="avatars"
        />
        <div class="feature">
          Trusted by <span class="detail-bold">5,000+</span>
        </div>
      </div>
      <img
        src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e36151945163e71934f5_Plant%202%20SVG.svg"
        loading="lazy"
        alt=""
        class="plant-2"
      /><img
        src="https://assets.website-files.com/6010de1e018a9658414084b1/6010e361c97df45caa09e12a_Plant%201%20SVG.svg"
        loading="lazy"
        alt=""
        class="plant-1"
      /> -->

      <div class="all-include container">
        <h3 class="title-2 cc-small">Toate planurile de design includ</h3>
        <div class="feature_grid">
          <div id="w-feature1" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6cac05d02ac165c04c1bd_pricing15.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Interacțiuni &amp; animații</h5>
            <p class="small-paragraph">
              Creăm interacțiuni și animații personalizate pentru a face site-ul
              dvs. să iasă în evidență, totul fără a pierde din performanță.<br />
            </p>
          </div>
          <div id="w-feature2" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6caf25a6dba0d43e2e281_pricing16.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Flexbox<br /></h5>
            <p class="small-paragraph">
              Construim site-uri flexibile și receptive oricărui ecran.<br />
            </p>
          </div>
          <div id="w-feature3" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6cae728b2e41e63883436_pricing8.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Fonturi personalizate<br /></h5>
            <p class="small-paragraph">
              Vă oferim posibilitatea să alegeți fontul preferat sau ne lăsați
              pe noi să facem alegerea ideală pentru tine.<br />
            </p>
          </div>
          <div id="w-feature4" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca4a69305d9570ea80c7_pricing7.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Încărcări de pagini foarte rapide<br /></h5>
            <p class="small-paragraph">
              Cea mai rapidă găzduire pe internet prin rețeaua noastră de CDN de
              nivel 1.Folosind infrastructura Amazon, Cloudfront și Fastly.<br />
            </p>
          </div>
          <div id="w-feature5" class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca5569305d47ffea80cb_pricing18.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">SSL și securitate încorporate<br /></h5>
            <p class="small-paragraph">
              24/7 monitorizarea găzduirii &amp; Certificatele SSL înseamnă că
              vă vom păstra site-ul în siguranță.<br />
            </p>
          </div>
          <div class="feature_wrap">
            <div class="feature_icon">
              <img
                src="https://assets-global.website-files.com/5bd161f014584e0578f724ec/5bd6ca6910ba2a291c7b2c4d_pricing12.svg"
                alt=""
              />
            </div>
            <h5 class="small-title">Scalare imediată<br /></h5>
            <p class="small-paragraph">
              Site-ul dvs. va fi rapid pentru primul sau al 1M -lea vizitator
              simultan. Nu vă faceți griji, puteți deveni popular peste
              noapte.<br />
            </p>
          </div>
        </div>

        <div class="title-wrap mt-5 pt-5">
          <div class="detail">Security Headers</div>
          <h1 class="display-heading">Cât de sigur este site-ul tău?</h1>
          <p>
            Hai să vedem, introdu in campul de mai jos domeniul tău. ex:
            surfverse.com
          </p>
          <form
            method="post"
            onsubmit="window.open('google.html', '_blank';return true;"
          >
            <input type="text" name="website" v-model="website" />
            <button type="submit" @click.stop.prevent="submit()">
              Verifica
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pricing',
  data() {
    return {
      website: 'surfverse.com'
    }
  },
  methods: {
    submit() {
      //if you want to send any data into server before redirection then you can do it here
      window.open(
        this.$router.push(
          (location.href =
            'https://securityheaders.com?q=' +
            this.website +
            '&hide=on&followRedirects=on')
        ),
        '_blank'
      )
    }
  }
}
</script>

<style>
#pricing .plant-1 {
  position: absolute !important;
  left: 0%;
  top: auto;
  right: auto;
  bottom: 0%;
}
#pricing .plant-2 {
  position: absolute !important;
  left: auto;
  top: auto;
  right: 0%;
  bottom: 0%;
}
#pricing img,
#pricing span {
  position: relative;
}
#pricing .content-section {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  overflow: hidden;
  min-height: 550px;
  padding: 80px 3%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  /* background-color: #fffcfc; */
}
#pricing .container {
  width: 100%;
  max-width: 1140px;
  margin-right: auto;
  margin-left: auto;
}
#pricing .title-wrap {
  display: block;
  max-width: 540px;
  margin-right: auto;
  margin-bottom: 64px;
  margin-left: auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}
#pricing .detail {
  margin-bottom: 4px;
  color: #ff725e;
  font-weight: 600;
  text-transform: uppercase;
}
#pricing .display-heading {
  margin-top: 0px;
  font-family: Oswald, sans-serif;
  color: var(--text-color);
  font-size: 52px;
  line-height: 1.1;
  letter-spacing: -0.03em;
}
#pricing p {
  margin-bottom: 10px;
  color: var(--text-color);
  font-size: 16px;
  line-height: 26px;
  font-weight: 400;
}
#pricing .pricing-grid {
  grid-column-gap: 32px;
  -ms-grid-columns: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}
#pricing .card-container {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 42px 24px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 20px;
  background: var(--grid-cell);
  border: var(--grid-cell-border);
}
#pricing .price {
  font-family: Recoleta, sans-serif;
  color: var(--text-color);
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}
#pricing .large-price-span {
  font-size: 52px;
  line-height: 70px;
  font-weight: 700;
  position: relative !important;
}
#pricing .pricing-description {
  margin-top: 20px;
  margin-bottom: 28px;
  padding: 10px 24px;
  border-radius: 400px;
  background-color: rgba(255, 114, 94, 0.08);
  color: #ff725e;
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  text-align: center;
}
#pricing .w-layout-grid {
  display: -ms-grid;
  display: grid;
  grid-auto-columns: 1fr;
  -ms-grid-columns: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  -ms-grid-rows: auto auto auto;
  grid-template-rows: auto auto auto;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
}
#pricing .feature-grid {
  margin-bottom: 50px;
  -ms-grid-columns: 1fr;
  grid-template-columns: 1fr;
  -ms-grid-rows: auto auto auto auto;
  grid-template-rows: auto auto auto auto;
}
#pricing .feature-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
#pricing .feature {
  margin-bottom: 0px;
  color: var(--text-color);
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding-top: 0;
}
#pricing .check-svg {
  margin-right: 12px;
}
#pricing .button {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 16px 62px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 12px;
  background-color: #00214d;
  white-space: nowrap;
}
#pricing .w-button {
  display: inline-block;
  padding: 9px 15px;
  background-color: #3898ec;
  color: white;
  border: 0;
  line-height: inherit;
  text-decoration: none;
  cursor: pointer;
  border-radius: 0;
}
#pricing img {
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
}
#pricing .title-2.cc-small {
  font-size: 18px;
}
#pricing .title-2 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  height: 100%;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  font-size: 24px;
  line-height: 100%;
  font-weight: 500;
}
#pricing .feature_wrap {
  width: 33%;
  padding-top: 30px;
  padding-right: 30px;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}
#pricing .feature_grid {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: start;
  -ms-flex-pack: start;
  justify-content: start;
  justify-items: start;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: start;
  -webkit-align-items: start;
  -ms-flex-align: start;
  align-items: start;
  -webkit-align-content: start;
  -ms-flex-line-pack: start;
  align-content: start;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
  box-shadow: inset 0 1px 0 0 rgb(0 0 0 / 10%);
  color: #888;
  font-size: 15px;
  line-height: 100%;
  font-weight: 500;
}
#pricing .feature_icon {
  display: block;
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  margin-left: -6px;
}
#pricing .small-title {
  display: inline-block;
  margin-top: 0px;
  margin-bottom: 10px;
  color: var(--text-color);
  font-size: 15px;
  line-height: 150%;
  font-weight: 500;
}
</style>
